<template>
  <ReassuranceItem data-test="reassurance-carrier">
    <template #icon>
      <IconLockUnlocked />
    </template>
    <template #content>
      <div class="w-full">
        <button
          class="flex w-full items-center justify-between text-left"
          @click="openSimUnlockedModal"
        >
          <span class="body-2 flex flex-col">
            {{ i18n(translations.carrier) }}
            <span class="caption">{{ i18n(translations.carrierCaption) }}</span>
          </span>

          <IconChevronRight />
        </button>
      </div>
      <SimUnlockedModal />
    </template>
  </ReassuranceItem>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { openModal } from '@ds/components/ModalBase'
import { IconChevronRight } from '@ds/icons/IconChevronRight'
import { IconLockUnlocked } from '@ds/icons/IconLockUnlocked'

import { MODAL_NAMES } from '~/scopes/product/pages/Product-JP/Product-JP.constants'
import SimUnlockedModal from '~/scopes/product/pages/Product-JP/components/SimUnlockedModal/SimUnlockedModal.vue'

import ReassuranceItem from '../ReassuranceItem/ReassuranceItem.vue'

import translations from './ItemCarrier.translations'

const i18n = useI18n()
const { trackClick } = useTracking()

const openSimUnlockedModal = () => {
  openModal(MODAL_NAMES.SIM_UNLOCKED)
  trackClick({
    zone: 'reassurance_list',
    name: 'sim_unlocked',
  })
}
</script>
